import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../../colors-v2';
import { TableBlogClassNames } from '../../const';
import { TableBaseProps } from './types';

const Main = styled.tr`
  color: ${colorsV2.black100};

  &.is-read-only {
    cursor: pointer;
    &:hover {
      background-color: ${colorsV2.gray10};
    }
  }
`;

interface AdminTableRowProps extends TableBaseProps {}

export const AdminTableRow = observer((props: AdminTableRowProps) => {
  const { children, attributes, element, isReadOnly } = props;

  return (
    <Main
      {...attributes}
      data-element-id={element.id}
      className={cl('table-blog-tr', element.id, TableBlogClassNames.TABLE, {
        'is-read-only': isReadOnly,
      })}
    >
      {children}
    </Main>
  );
});
